module.exports = __webpack_public_path__ + "static/media/staman_acres.aec304ba.pdf";